import cn from 'classnames'

import { PrivacyPolicyProps } from './PrivacyPolicy.types'

export const PrivacyPolicy = (props: PrivacyPolicyProps) => {
    const { className } = props

    return (
        <section className={cn('py-24 md:py-32 bg-gradient-to-b from-gray-50 to-white', className)}>
            <div className='container mx-auto px-4 max-w-4xl'>
                <div className='mb-12'>
                    <h1 className='text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4'>
                        Privacy Policy
                    </h1>
                    <p className='text-gray-600'>Last updated on 23 April 2024</p>
                </div>

                <div className='bg-white rounded-lg shadow-lg p-8 md:p-12 prose prose-lg max-w-none'>
                    <p className='text-gray-700 mb-8'>
                        Welcome to nexly ("we" or "us"). This Privacy Policy is designed to help you understand how we collect, use, disclose, and safeguard your personal information when you use our website and related services.
                    </p>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>1. Information We Collect</h2>

                    <h3 className='text-xl font-semibold text-gray-900 mt-6 mb-3'>1.1 Personal Information</h3>
                    <p className='text-gray-700 mb-4'>
                        We may collect personal information, such as your name, email address, and other contact details when you voluntarily provide it to us, such as when you register for an account, subscribe to newsletters, or contact us through the website.
                    </p>

                    <h3 className='text-xl font-semibold text-gray-900 mt-6 mb-3'>1.2 Usage Information</h3>
                    <p className='text-gray-700 mb-4'>
                        We may collect information about your use of the website, including your IP address, browser type, device information, and pages visited. This information helps us analyze trends, administer the site, and improve user experience.
                    </p>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>2. How We Use Your Information</h2>
                    <p className='text-gray-700 mb-4'>
                        We use the collected information for various purposes, including:
                    </p>
                    <ul className='list-disc list-inside text-gray-700 mb-4 space-y-2'>
                        <li>Providing and maintaining the website</li>
                        <li>Communicating with you about your account and our services</li>
                        <li>Sending newsletters, promotional materials, and other information you request</li>
                        <li>Analyzing website usage and improving our services</li>
                    </ul>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>3. Sharing Your Information</h2>
                    <p className='text-gray-700 mb-4'>
                        We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this Privacy Policy. We may share information with trusted third-party service providers who assist us in operating our website or conducting our business.
                    </p>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>4. Cookies and Similar Technologies</h2>
                    <p className='text-gray-700 mb-4'>
                        We use cookies and similar technologies to enhance your experience on our website. You can control cookies through your browser settings, but disabling them may affect your ability to use certain features of the site.
                    </p>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>5. Your Choices</h2>
                    <p className='text-gray-700 mb-4'>
                        You can manage your communication preferences by unsubscribing from newsletters or adjusting your account settings. You may also contact us to update or delete your personal information.
                    </p>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>6. Security</h2>
                    <p className='text-gray-700 mb-4'>
                        We take reasonable measures to protect the security of your personal information. However, no method of transmission over the internet or electronic storage is completely secure. Therefore, we cannot guarantee absolute security.
                    </p>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>7. Children's Privacy</h2>
                    <p className='text-gray-700 mb-4'>
                        Our website is not directed to individuals under the age of 18. If you become aware that a child has provided us with personal information, please contact us, and we will take steps to remove such information.
                    </p>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>8. Changes to This Privacy Policy</h2>
                    <p className='text-gray-700 mb-4'>
                        We may update this Privacy Policy periodically. We will notify you of any changes by posting the new Privacy Policy on this page. Your continued use of the website after such modifications will constitute your acknowledgment of the modified Privacy Policy.
                    </p>

                    <h2 className='text-2xl font-bold text-gray-900 mt-8 mb-4'>9. Contact Us</h2>
                    <p className='text-gray-700 mb-4'>
                        If you have any questions about this Privacy Policy, please contact us at{' '}
                        <a href='mailto:sales@nexly.tech' className='text-primary hover:text-primary-hover'>
                            sales@nexly.tech
                        </a>
                    </p>
                </div>
            </div>
        </section>
    )
}
